(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    (() => {
    // İndirim rozetinin nabız animasyonunu sadece ekrandaki rozetlerde çalıştır.
    // Yüzlerce kartlık listelerde tüm rozetler aynı anda canlanınca sayfa kasılıyordu.
    if (window.__priceBadgePulse || !('IntersectionObserver' in window)) return;
    window.__priceBadgePulse = true;

    const observed = new WeakSet();
    const io = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        entry.target.classList.toggle('price-badge--live', entry.isIntersecting);
        if (!entry.target.isConnected) {
          io.unobserve(entry.target);
          observed.delete(entry.target);
        }
      }
    });

    const observe = (badge) => {
      if (observed.has(badge)) return;
      observed.add(badge);
      io.observe(badge);
    };

    const scan = (root) => {
      if (root.matches?.('.price-badge--discount')) observe(root);
      root.querySelectorAll?.('.price-badge--discount').forEach(observe);
    };

    scan(document);
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => node.nodeType === 1 && scan(node));
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["slideshow-progress"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('slideshow-component[autoplay]').forEach((slideshow) => {
      const bar = slideshow.querySelector('.slideshow-progress__bar');
      if (!bar) return;

      const duration = slideshow.getAttribute('autoplay');
      if (duration) slideshow.style.setProperty('--autoplay-duration', `${duration}s`);

      function resetBar() {
        bar.classList.remove('is-filling');
        void bar.offsetWidth; // reflow — animasyonu sıfırla
        bar.classList.add('is-filling');
      }

      resetBar();
      slideshow.addEventListener('slideshow:select', resetBar);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    class TextBlockReadMore extends HTMLElement {
    connectedCallback() {
      this.inner  = this.querySelector('.text-block__read-more-inner');
      this.btn    = this.querySelector('.text-block__read-more-btn');
      this.label  = this.btn?.querySelector('span');

      if (!this.btn || !this.inner) return;

      this.readMoreLabel = this.btn.dataset.readMoreLabel || 'Devamını gör';
      this.readLessLabel = this.btn.dataset.readLessLabel || 'Daha az göster';
      this.expanded      = false;

      /* İçerik zaten sığıyorsa butonu gizle */
      this._checkOverflow();
      window.addEventListener('resize', () => this._checkOverflow());

      this.btn.addEventListener('click', () => this._toggle());
    }

    _checkOverflow() {
      if (!this.inner) return;
      const maxH    = parseInt(getComputedStyle(this).getPropertyValue('--read-more-height')) || 120;
      const content = this.inner.querySelector('.text-block__read-more-content');
      const isOver  = content && content.scrollHeight > maxH;

      this.btn.style.display = isOver || this.expanded ? '' : 'none';
    }

    _toggle() {
      this.expanded = !this.expanded;
      this.inner.classList.toggle('is-expanded', this.expanded);
      this.btn.setAttribute('aria-expanded', String(this.expanded));
      if (this.label) {
        this.label.textContent = this.expanded ? this.readLessLabel : this.readMoreLabel;
      }
    }
  }

  if (!customElements.get('text-block-read-more')) {
    customElements.define('text-block-read-more', TextBlockReadMore);
  }

  /* Read more wrapper'ı custom element olarak kullan */
  document.querySelectorAll('.text-block--has-read-more').forEach((el) => {
    if (el.tagName.toLowerCase() !== 'text-block-read-more') {
      const wrapper = document.createElement('text-block-read-more');
      wrapper.className = el.className;
      [...el.attributes].forEach(attr => wrapper.setAttribute(attr.name, attr.value));
      wrapper.innerHTML = el.innerHTML;
      el.replaceWith(wrapper);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
